import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("user")) || null);
	const login = (user) => {
		setUser(user);
		sessionStorage.setItem("user", JSON.stringify(user));
	};
	const logout = () => {
		sessionStorage.clear();
		setUser(null);
	}
	return (
		<AuthContext.Provider value={{ user, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
